export function generatePassword(): string {
	const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*';
	const minLength = 6;
	const maxLength = 20;

	// Функция для генерации случайного числа в диапазоне [min, max)
	const randomInt = (min: number, max: number): number => Math.floor(Math.random() * (max - min)) + min;

	// Генерация случайной длины пароля
	const length = randomInt(minLength, maxLength + 1);

	// Генерация пароля
	let password = '';
	for (let i = 0; i < length; i++) {
		const randomChar = charset[randomInt(0, charset.length)];
		password += randomChar;
	}

	return password;
}

export function truncateText(text: string | undefined, maxLength = 50): string {
	if (!text) {
		return '';
	}
	return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
}